module.exports = __webpack_public_path__ + "static/media/reps-data.e1f641d4.csv";